import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private KEY = 'ng_biilog_gerencial';
  private KEYID = 'admin_id';
  private KEYP = 'ng_biilog_gerencial_permissions';

  public getToken() {
    return localStorage.getItem(this.KEY);
  }

  public saveToken(token: string, account: any) {
    localStorage.setItem(this.KEY, token);
    localStorage.setItem(this.KEYID, account.id.toString());
    localStorage.setItem(this.KEYP, JSON.stringify(account.permissions));
  }

  public deleteToken() {
    localStorage.removeItem(this.KEY);
  }
}
